
@switch (columnId) {
  @case ('id') {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
    <lib-table-column-sort [key]="element.id ?? 0"></lib-table-column-sort>
  }
  @case ('name') {
    <lib-text-table-column>
      {{ element.name }}
    </lib-text-table-column>
  }
  @case ('description') {
    <lib-text-table-column>
      {{ element.description }}
    </lib-text-table-column>
  }
  @default {
  }
}
